/*
import * as Sentry from "@sentry/vue";
Sentry.init({
    dsn: "https://49b35c6ec6a11eaaef635da6d5d0aebf@o4506859832606720.ingest.us.sentry.io/4506859834638336",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/vaurioauto\.fi$/,/^https:\/\/vaurioauto\.iltavuoro\.dev$/],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
*/
import {createApp} from 'vue/dist/vue.esm-bundler';
import {createPinia} from 'pinia';
import {apiURL} from './settings.js'
import {TStrings} from './global.js'
import i18n from './i18n.js'
import salesRouter from './router/sales.js'
import companyRouter from './router/company.js'
import buyerRouter from './router/buyer.js'

import CompRegForm from './components/CompRegForm.vue';
import LoggedInUser from './components/buyerComponents/LoggedInUser.vue';
import Loader from '@components/salesComponents/Loader.vue';

import T from './components/T.vue';
//import eventBus from './eventBus.js';
//import eventBusPlugin from "./eventBusPlugin";

var $j = jQuery.noConflict();
const pinia = createPinia()

const mountHeaderApp = document.querySelector("#header-app");
if(mountHeaderApp) {
    const app = createApp();
    app.component('LoggedInUser', LoggedInUser);
    app.use(pinia);
    app.use(i18n);
    app.mount('#header-app');
}

const mountElApp = document.querySelector("#app");
if(mountElApp) {
    const app = createApp(
        {
            props: ['templatebase'],
            provide() {
                // use function syntax so that we can access `this`
                return {
                    templatebase: this.templatebase
                }
            }
        },
        { ...mountElApp.dataset }
    );

    //app.use(eventBusPlugin, eventBus);
    app.use(salesRouter);
    app.use(pinia);
    app.use(i18n);
    app.component('Loader', Loader);
    app.mount('#app');
}

const mountCompanyApp = document.querySelector("#comp-login-form");
if(mountCompanyApp) {
    const CompanyApp = createApp({});

    CompanyApp.provide('apiURL', apiURL);    
    CompanyApp.use(companyRouter);
    CompanyApp.use(i18n);
    CompanyApp.use(pinia);    
    CompanyApp.mount('#comp-login-form');
}

const mountBuyerApp = document.querySelector("#buyer-app");
if(mountBuyerApp) {
    const buyerApp = createApp(
        {
            props: ['templatebase'],
            provide() {
                // use function syntax so that we can access `this`
                return {
                    templatebase: this.templatebase,
                    jQuery: $j
                }
            }
        },
        { ...mountBuyerApp.dataset }
    );

    //app.use(eventBusPlugin, eventBus);
    buyerApp.use(buyerRouter);
    buyerApp.use(pinia);
    buyerApp.use(i18n);
    buyerApp.mount('#buyer-app');
}

const compRegApp = createApp({
    // Configuration options
    mounted() {
        console.log('Company register form app mounted');
    },

    data() {
        return {
            apiUrl: 'https://api.vaurioauto.fi/api/'
        }
    },
});
compRegApp.provide('apiURL', apiURL);
compRegApp.provide('TStrings', TStrings);
compRegApp.component('T', T);
compRegApp.component('CompRegForm', CompRegForm);
compRegApp.mount('#company-register-app');
